<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <!-- Widgets-->
      <v-flex d-flex lg4 sm6 xs12>
        <widget icon="view_list" title="200" :subTitle="$t('Montyly Sale (Item)', ['50'])" :supTitle="$t('Point')" color="#00b297"/>
      </v-flex>
      <v-flex d-flex lg4 sm6 xs12>
        <widget icon="shopping_cart" title="80" :subTitle="$t('Customer Order', [''])" :supTitle="$t('in 7 day')" color="#dc3545"/>
      </v-flex>
      <v-flex d-flex lg4 sm6 xs12>
        <widget icon="add" title="33.45%" :subTitle="$t('widgetAverageDuration', ['13%'])"  :supTitle="$t('widgetUniqueVisits')" color="#0866C6"/>
      </v-flex>
      <v-flex d-flex lg12 sm6 xs12>
        <v-container>
            <center><h2>Monthly Chart</h2></center>
            <line-chart></line-chart>
        </v-container>
        

      </v-flex>
      <!-- Widgets Ends -->
      <!-- Statistics Ends -->
      <v-flex d-flex lg6 sm6 xs12>
        <v-container>

        </v-container>
        
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import LineChart from '@/components/statistics/LineChart'

export default {
  name: 'Dashboard2',
  components: {
    LineChart,
  
  },
  data() {
    return {

    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Dashboard2.vue